﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { useToasts } from "react-toast-notifications";
import _ from "lodash";

import { toast, validRoles } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_element, customStyles } from "../versions.constants";
import { useVersion } from "@/hooks/maintainers/versions";

import { NoOptionsMessage } from "@/components/ReactSelect/NoOptions";

const VersionsForm = ({ confirmSave, isLoadingSave, customers }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, version_id } = useParams();
	const navigate = useNavigate();

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const [data, setData] = useState({ ...base_element });

	const { data: response, isLoading } = useVersion(version_id);

	useEffect(() => {
		if (response) {
			setData(response.detail);
		}
	}, [response]);

	const handleClose = () => {
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/versiones");
	};

	const validSave = () => {
		if (!data.version) {
			toast(addToast, "Debe ingresar una versión para guardar.", "error");
			return false;
		}
		if (!data.git_restoration_point_driver) {
			toast(addToast, "Debe ingresar un punto de restauración para la API.", "error");
			return false;
		}
		if (!data.git_restoration_point_app) {
			toast(addToast, "Debe ingresar un punto de restauración para el Front.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			confirmSave(data);
		}
	};

	const handleChangeCustomers = (value) => {
		let newCustomers;
		if (value.length > 0 && value[0].value === "all") {
			newCustomers = _.map(customers, "value");
		} else {
			newCustomers = value.length > 0 ? _.map(value, "value") : [];
		}

		setData({ ...data, customers: newCustomers });
	};

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Versión</h4>
			</Modal.Header>
			<Modal.Body>
				{isLoading || isLoadingSave ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Versión</Form.Label>
								<Form.Control
									value={data ? data.version : ""}
									onChange={(e) =>
										setData({
											...data,
											version: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Punto de restauración API</Form.Label>
								<Form.Control
									value={data ? data.git_restoration_point_driver : ""}
									onChange={(e) =>
										setData({
											...data,
											git_restoration_point_driver: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Punto de restauración Front</Form.Label>
								<Form.Control
									value={data ? data.git_restoration_point_app : ""}
									onChange={(e) =>
										setData({
											...data,
											git_restoration_point_app: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>
						<Col md={6} xs={6}>
							<Form.Group as={Row}>
								<Col sm>
									<Form.Check
										checked={data && data.stable && Number(data.stable) !== 0}
										type="switch"
										id="estable_version"
										label="Estable"
										onChange={() =>
											setData({
												...data,
												stable: !data.stable,
											})
										}
									/>
								</Col>
							</Form.Group>
						</Col>
						<Col md={6} xs={6}>
							<Form.Group as={Row}>
								<Col sm>
									<Form.Check
										checked={data && data.active && Number(data.active) !== 0}
										type="switch"
										id="active_version"
										label="Activo"
										onChange={() =>
											setData({
												...data,
												active: !data.active,
											})
										}
									/>
								</Col>
							</Form.Group>
						</Col>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Clientes</Form.Label>
								<Select
									value={customers && customers.filter((c) => data && data.customers && data.customers.includes(c.value))}
									isMulti
									placeholder={<div>Seleccione</div>}
									options={
										customers && [
											{
												value: "all",
												label: "Seleccionar todos",
											},
											...customers,
										]
									}
									onChange={(value) => {
										handleChangeCustomers(value);
									}}
									components={{ NoOptionsMessage }}
									styles={customStyles}
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isLoading && (
					<Button variant="success" onClick={handleSave} disabled={isLoading || (isLoadingSave && true)}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default VersionsForm;
